import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [resetPasswordMode, setResetPasswordMode] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors

    try {
      const response = await fetch('https://cloudapi.emedhatechnologies.com/auth/api/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setResetPasswordMode(true);
      } else {
        setError(data.error || 'Failed to send password reset email');
      }
    } catch (error) {
      setError('Failed to send password reset email');
    }
  };

  return (
    <div style={{ marginTop: '5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 1rem', }}>
      <div style={{ maxWidth: '500px', width: '100%', padding: '2rem', backgroundColor: '#f9f9f9', border: '1px solid #ccc', borderRadius: '10px', boxSizing: 'border-box', fontFamily: '"Courier New", Courier, monospace', }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '1.5rem', fontWeight: 'bold', color: '#222' }}>
          Reset Your Password
        </h1>

        {error && (
          <div role="alert" style={{ marginBottom: '1rem', padding: '0.75rem 1rem', backgroundColor: '#f8d7da', color: '#842029', border: '1px solid #f5c2c7', borderRadius: '0', }} >
            {error}
          </div>
        )}

        {resetPasswordMode && (
          <div role="alert" style={{ marginBottom: '1rem', padding: '0.75rem 1rem', backgroundColor: '#d1e7dd', color: '#0f5132', border: '1px solid #badbcc', borderRadius: '0', }}>
            Check your email for a password reset link.
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold', color: '#333' }} >
            Email address
          </label>
          <input id="email" type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} required
            style={{ width: '100%', padding: '10px 15px', fontSize: '1rem', border: '1px solid #000', borderRadius: '0', marginBottom: '1rem', boxSizing: 'border-box', fontFamily: '"Courier New", Courier, monospace', }}
          />

          <div style={{ marginBottom: '1rem' }}>
            <ReCAPTCHA sitekey="6LfB4CIqAAAAABTTABOif9nMWUiFuMfIp31_UU5I" />
          </div>

          <button type="submit" style={{ width: '100%', padding: '12px', backgroundColor: '#07526f', color: 'white', border: '1px solid black', borderRadius: '0', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer', fontFamily: '"Courier New", Courier, monospace', transition: 'background-color 0.3s ease', }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#053a52')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#07526f')}
          >
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
